//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'
import { Utils } from '../util/utils'

export class OpModule implements IReferenceType, IOpChangeState, IJsonSerializable {

    //#region Members

    public idModule: number
    public name: string
    public idDescr: number
    public descr: OpDescr

    //#endregion

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    //#endregion


    //#region IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdModule
    }

    public getReferenceKey(): number {
        return this.idModule
    }

    public getReferenceValue(): any {
        return this
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || Utils.isJSONCompressed(opObj)) {
                this.idModule = opObj.IM
                this.name = opObj.N
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O
            } else {
                this.idModule = opObj.ID_MODULE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                IM: this.idModule,
                N: this.name,
                I: this.idDescr,
                D: this.descr != null ? this.descr.toJSON(compressed) : null,
                O: this.opState,
            }

            Utils.setJSONCompressedFlag(result)

            return result
        }

        return {
            ID_DESCR: this.idDescr,
            ID_MODULE: this.idModule,
            NAME: this.name,
            _Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
            OpState: this.opState
        }
    }

    //#endregion


    //#region toString

    public toString(): string {
        if (this.descr != null) {
            return this.descr.description
        }

        return this.name
    }

    //#endregion


    //#region loadNavigationProperties

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpModule[]): JQueryPromise<OpModule[]> {
        var defered = $.Deferred<OpModule[]>()

        defered.resolve(list)

        return defered.promise()
    }

    //#endregion

}